package routing

interface DestinationRoute {
    val name: String
    val routeKey: String
    val route: Map<String, String>
}

fun DestinationRoute.stringify() = "${routeKey}:${name}"